$(function() {
    $('.btn-load-line').on('click', function(e) {
        e.preventDefault();
        $('.timeline--entry').removeClass('hide');
        $('.line-more').addClass('hide');
        $('.about-us').addClass('full-height');
    })
})